import React from "react";
import { LoaderWrapper } from "@/components/Loader/style";
import { CircularProgress } from "@mui/material";

interface LoaderProps {
	fixed?: boolean;
}

export default function Loader({ fixed = true }: LoaderProps) {
	return (
		<LoaderWrapper fixed={fixed}>
			<CircularProgress />
		</LoaderWrapper>
	);
}
